import ChartBox from "components/ChartBox"
import ChartTooltip from "components/Charts/ChartTooltip"
import Lines from "components/Charts/Nivo/Lines"
import { useEffect, useState } from "react"

const data = [
	{
		"id": "IMC",
		"data": [
			{
				"x": "Q1",
				"y": 50
			},
			{
				"x": "Q2",
				"y": 52
			},
			{
				"x": "Q3",
				"y": 48
			},
			{
				"x": "Q4",
				"y": 43
			},
		]
	},
]

const LifeIMC = () => {
	const [mockData, setMockData] = useState<any>(data);

	const tooltip = (values: any) => {
		const { point } = values;
		return (
			<ChartTooltip
				label={`${point.data.x} - ${point.data.y} kg/m²`}
				value={point.data.yStacked}
				color={point.color}
			/>
		)
	}

	return (
		<ChartBox title="Controle de IMC">
			<Lines
				data={mockData}
				tooltip={tooltip}
			/>
		</ChartBox>
	)
}

export default LifeIMC
